module.exports = __webpack_public_path__ + "4c9a04b7fe8f0ff4e64d9252e981269a.svg";